import Vue from 'vue'
import Router from 'vue-router'
import product from '@/views/product/index.vue'
Vue.use(Router)

let kejianrouter = new Router({
  mode: 'hash', // 使用hash模式
  routes: [{
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页', icon: 'dashboard', affix: true }
    },{
      path: '/product',
      name: 'product',
      component: product,
      meta: { title: '产品中心'},
    },{
      path: '/detail',
      name: 'detail',
      component: () => import('@/views/product/detail.vue'),
      meta: { title: '产品详情'}
    },{
      path: '/cloud',
      name: 'cloud',
      component: () => import('@/views/cloud/index.vue'),
      meta: { title: '云平台', icon: 'dashboard', affix: true }
    },{
      path: '/authentication',
      name: 'authentication',
      component: () => import('@/views/service/authentication.vue'),
      meta: { title: '检测认证', icon: 'dashboard', affix: true }
    },{
      path: '/customized',
      name: 'customized',
      component: () => import('@/views/service/customized.vue'),
      meta: { title: '需求定制', icon: 'dashboard', affix: true }
    },{
      path: '/warranty',
      name: 'warranty',
      component: () => import('@/views/service/warranty.vue'),
      meta: { title: '保修服务', icon: 'dashboard', affix: true }
    },{
      path: '/building',
      name: 'building',
      component: () => import('@/views/scheme/building.vue'),
      meta: { title: '智慧建筑', icon: 'dashboard', affix: true }
    },{
      path: '/city',
      name: 'city',
      component: () => import('@/views/scheme/city.vue'),
      meta: { title: '智慧城市', icon: 'dashboard', affix: true }
    },{
      path: '/energy',
      name: 'energy',
      component: () => import('@/views/scheme/energy.vue'),
      meta: { title: '智慧能源', icon: 'dashboard', affix: true }
    },{
      path: '/industry',
      name: 'industry',
      component: () => import('@/views/scheme/industry.vue'),
      meta: { title: '智慧工业', icon: 'dashboard', affix: true }
    },{
      path: '/power',
      name: 'power',
      component: () => import('@/views/scheme/power.vue'),
      meta: { title: '智慧电力', icon: 'dashboard', affix: true }
    },{
      path: '/about',
      name: 'about',
      component: () => import('@/views/about/index.vue'),
      meta: { title: '关于我们', icon: 'dashboard', affix: true }
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default kejianrouter
